<template>
    <b-col md="12" sm="8">
      <b-card no-body class="mx-4">
        <b-card-body class="p-4">
          <b-form v-on:submit.prevent="onSubmit">
            <h1>{{this.$route.name}}</h1>
            <b-row v-if="edicao || visualizacao">
              <b-col cols="2">
                <b-form-group label="Nº do Cadastro: *">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nº do sistema cliente"
                                  autocomplete="num"
                                  :disabled="true"
                                  v-model.trim="idEditar"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="8">
                <b-form-group label="Nome do Sistema: *">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome do sistema cliente"
                                  autocomplete="nome"
                                  :disabled="visualizacao"
                                  v-model.trim="$v.form.nome.$model"
                                  :state="chkState('nome')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback3">Nome do Sistema é um campo obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="Área Responsável: *">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Área responsavel"
                                  autocomplete="areaResponsavel"
                                  v-model="$v.form.areaResponsavel.$model"
                                  :disabled="visualizacao"
                                  :state="chkState('areaResponsavel')"
                                  autofocus/>
                    <b-form-invalid-feedback id="input1LiveFeedback1">Área Responsável é um campo obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="5">
                <b-form-group label="Nome do Responsável: *">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  placeholder="Nome do responsável"
                                  autocomplete="nomeResponsavel"
                                  :disabled="visualizacao"
                                  v-model.trim="$v.form.nomeResponsavel.$model"
                                  :state="chkState('nomeResponsavel')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback7">Nome do Responsável é um campo obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-form-group label="E-mail do Responsável: *">
                  <b-input-group class="mb-3">
                    <b-form-input type="text"
                                  class="form-control"
                                  id="confirmar-email"
                                  placeholder="E-mail do responsável"
                                  :disabled="visualizacao"
                                  autocomplete="emailResponsavel"
                                  v-model.trim="$v.form.emailResponsavel.$model"
                                  :state="chkState('emailResponsavel')"/>
                    <b-form-invalid-feedback id="input1LiveFeedback8">E-mail do Responsável é um campo obrigatório, , e deve ser um
                      endereço de e-mail válido.
                    </b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Telefone (Ramal da Área):">
                  <b-input-group class="mb-3">
                    <b-form-input v-mask="'#####-####'"
                                  type="text"
                                  class="form-control"
                                  :disabled="visualizacao"
                                  autocomplete="telefone"
                                  v-model.trim="telefone"/>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="10">
                <b-form-group label="Descrição: *" id="fieldset-2" label-for="input-2">
                  <b-input-group class="mb-3">
                     <b-form-textarea
                                  id="textarea-auto-height"
                                  no-auto-shrink
                                  no-resize
                                  rows="5"
                                  :disabled="visualizacao"
                                  aria-label="Descrição"
                                  v-model.trim="$v.form.descricao.$model"
                                  :state="chkState('descricao')"
                                  class="form-control"
                                  ></b-form-textarea>
                    <b-form-invalid-feedback id="input1LiveFeedback3">Descrição é um campo obrigatório.</b-form-invalid-feedback>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          <hr>
          <span v-if="visualizacao">
            <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col">Data Alteração</th>
                  <th scope="col">Alterado por</th>
                  <th scope="col">Nome do Sistema</th>
                  <th scope="col">Área Responsável</th>
                  <th scope="col">Nome do Responsável</th>
                  <th scope="col">E-mail</th>
                  <th scope="col">Telefone</th>
                  <th scope="col">Descrição</th>
                </tr>
              </thead>

              <tbody v-if="startHistorico">
                <tr class="action" v-for="historico in historicos" :key="historico.id">

                  <td>{{format_date(historico.created_at)}}</td>
                  <td>{{historico.cpf_usuario}}</td>
                  <td>{{historico.nome}}</td>
                  <td>{{historico.area_responsavel}}</td>
                  <td>{{historico.nome_responsavel}}</td>
                  <td>{{historico.email_responsavel}}</td>
                  <td>{{historico.telefone ? historico.telefone : 'N/A'}}</td>
                  <td style="width: 15%">
                      <span>
                        <b-button v-b-modal="'modal'+historico.id" class="btn btn-sm btn-secondary action" title="Descrição"><i class="fa fa-search"></i></b-button>
                      </span>
                  </td>
                  <b-modal :id="'modal'+historico.id" title="Descrição" size="lg" ok-title="Voltar"  ok-only :ok-variant="'secondary'">
                    <b-card-body>
                      <b-row>
                        <b-col cols="12">
                          <b-form-group id="fieldset-2" label-for="input-2">
                            <b-input-group class="mb-3">
                              <b-form-textarea
                                            id="textarea-auto-height"
                                            no-auto-shrink
                                            no-resize
                                            rows="5"
                                            :disabled="true"
                                            aria-label="Descrição"
                                            v-model.trim="historico.descricao"
                                            class="form-control"
                                            ></b-form-textarea>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-modal>
                </tr>
              </tbody>
              <tbody v-else>
                <tr class="action">
                  <td colspan="9">Nenhum registro de alterações...</td>
                </tr>
              </tbody>
              </table>
          </span>
        </b-card-body>
        <b-card-footer class="p-12">
          <b-row>
            <b-col v-if="!loading && !visualizacao" md="3">
              <b-button block variant="primary" :disabled="disable_buttons" v-on:click="onSubmit">
                <i class="fa fa-plus"></i>&nbsp;
                <span>Salvar</span>
              </b-button>
            </b-col>
            <b-col v-if="loading && !visualizacao" md="3">
              <b-button block variant="primary" :disabled="true" v-on:click="onSubmit">
                <b-spinner small type="grow"></b-spinner>Salvando...
              </b-button>
            </b-col>
            <b-col v-if="visualizacao" md="3">
              <b-button block variant="primary" :disabled="disable_buttons" v-on:click="navigate('/dados/editar/' + idEditar)">
                <i class="fa fa-plus"></i>&nbsp;
                <span>Alterar</span>
              </b-button>
            </b-col>
            <b-col md="3">
              <b-button block variant="secondary" :disabled="disable_buttons" @click="navigate('/formularios')">
                <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>
      </b-card>
    </b-col>
</template>

<script>
import Vue from 'vue'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required, email} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import moment from 'moment'

miniToastr.init()

export default {
  name: 'ServicoCliente',
  components: {
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      nome: {
        required
      },
      areaResponsavel: {
        required
      },
      nomeResponsavel: {
        required
      },
      emailResponsavel: {
        required,
        email
      },
      descricao: {
        required
      },
      clientId: {
        required
      },
      clientSecret: {
        required
      },
      status: {
        required
      }
    }
  },
  created () {
    if (!this.can('questionario.update')) {
      this.$router.push('/')
    }

    if (this.$route.params.id) {
      this.setEdit(this.$route.params.id)
    }
  },
  data () {
    return {
      loading: false,
      form: {
        nome: '',
        areaResponsavel: '',
        nomeResponsavel: '',
        emailResponsavel: '',
        descricao: '',
        clientId: '',
        clientSecret: '',
        status: true

      },
      idEditar: '',
      telefone: '',
      options: [
        { text: 'Ativo', value: true },
        { text: 'Inativo', value: false }

      ],
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false,
      historicos: []

    }
  },
  computed: {
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    },
    visualizacao () {
      return this.$route.matched.some(({ name }) => name === 'Visualizar Dados do Sistema')
    },
    edicao () {
      return this.$route.matched.some(({ name }) => name === 'Alterar Dados do Sistema')
    },
    startHistorico () {
      let validation = true

      if (this.historicos === undefined) {
        validation = false
      }

      if (this.historicos.length < 1) {
        validation = false
      }

      return validation
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    format_date (value) {
      if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
      }
    },
    setEdit (id) {
      Vue.http.get('api/sistema/' + id).then(response => {
        let data = response.body.data[0]

        this.idEditar = data.id
        this.form.nome = data.nome
        this.form.areaResponsavel = data.area_responsavel
        this.form.nomeResponsavel = data.nome_responsavel
        this.form.emailResponsavel = data.email_responsavel
        this.telefone = data.telefone
        this.form.descricao = data.descricao
        this.form.clientId = data.client_id
        this.form.clientSecret = data.client_secret
        this.form.status = data.status
        this.historicos = data.historico
      })
    },
    salvar () {
      let form = this.$v.form
      let data = {
        id: this.idEditar,
        nome: form.nome.$model,
        area_responsavel: form.areaResponsavel.$model,
        nome_responsavel: form.nomeResponsavel.$model,
        email_responsavel: form.emailResponsavel.$model,
        telefone: this.telefone,
        descricao: form.descricao.$model,
        client_id: form.clientId.$model,
        client_secret: form.clientSecret.$model,
        status: form.status.$model
      }

      this.loading = true
      Vue.http.post('api/sistema', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.setEdit(this.idEditar)
          this.$router.push({path: '/dados/visualizar/' + this.idEditar})
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      if (!this.visualizacao) {
        const field = this.$v.form[val]
        if (!field.$model && !this.salvarForm) {
          return null
        }

        return !field.$dirty || !field.$invalid
      }
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/cliente/perfil/DadosCliente.vue